/**
 * Wishlist funcitonality
*/
let wishlisted_products = [];
let wishlist_product_ids = [];

// addWishlistProducts(customerId);
const getWishlistProducts = async (customerID) => {
  const body = JSON.stringify({ customerId: customerID });

  try {
    const response = await fetch('/apps/proxy/get-selected-products',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: body
      });

    const data = await response.json();

    if (response.ok) {
      wishlisted_products = data.product_data;
      wishlist_product_ids = data.products;
      console.log(data, 'wishlist Items');
      return true;
    } else {
      console.error('Error:', data);
      return false;
    }
  } catch (error) {
    console.error('Network error:', error);
    return false;
  }
};
const addWishlistProducts = async (customerID, products) => {
  const body = JSON.stringify({
    customerId: customerID,
    product_ids: products
  });
  try {
    const response = await fetch('/apps/proxy/store-wishlist-products',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: body
      });

    const data = await response.json();

    if (response.ok) {
      console.log(data, 'wishlist Items');
      return true;
    } else {
      console.error('Error:', data);
      return false;
    }
  } catch (error) {
    console.error('Network error:', error);
    return false;
  }
};
const applyWishlistBtns = (products_data) => {
  let wishlistBtns = document.querySelectorAll('[data-add-wishlist]');
  if (wishlistBtns.length > 0) {
    wishlistBtns.forEach(btn => {
      if (products_data.includes(parseInt(btn.dataset.productId))) {
        btn.classList.add('in-wishlist');
      } else {
        btn.classList.remove('in-wishlist');
      }
    })
  }
}
const removeWishlistItem = (nodes) => {
  if (nodes.length > 0) {
    nodes.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        let _this = e.currentTarget;
        let currProductID = parseInt(_this.dataset.productId);
        let productTitle = wishlisted_products.find(item => {return item.id == currProductID});

        wishlist_product_ids = wishlist_product_ids.filter(number => number != currProductID);
        await addWishlistProducts(window.globalVariables.customer_id, wishlist_product_ids);    
        window.notificationEle.updateNotification('Saved Favorites', `${productTitle?.title ? `${productTitle.title}` : `The product`} ${window.wishlistStrings.wishlist_removed_item}`, {
          type: 'success',
          timeout: 4000
        });
        _this.closest('.product-card-item').remove();
      })  
    });
  }
}
const renderWishlistItems = (products_data) => {
  let html = '';
  if (products_data.length > 0) {
    html = `
      <div class="row wishlist-items-wrapper row-cols-2 row-cols-lg-3">
        ${products_data.map(product => {
      return `
            <div class="product-card-item col">
              <div class="position-relative product-card-item-inner">
                <button type="button" class="wishlist-remove-trigger btn btn-outline-secondary position-absolute" title="${window.wishlistStrings.remove_from_wishlist}" data-remove-wishlist data-product-id="${product.id}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"/>
                  </svg>
                </button>
                <a href="/products/${product.handle}" title="${product.title}" class="product-media">
                  <img src="${product.image}" alt="${product.title}" width="1000" height="1000" />
                </a>
                <div class="content-wrapper">
                  <a href="/products/${product.handle}" title="${product.title}" class="product-title my-2 d-block">${product.title}</a>
                  ${(product.inventory_policy == 'continue' || product.inventory_quantity > 0)
                  ? `<button type="button" class="btn btn-fuchsia w-100 px-2" data-move-wishlist-to-cart data-product-id="${product.id}" data-variant-id="${product.variant_id}">${window.wishlistStrings.add_to_wishlist}</button>`
                  : `<button type="button" class="btn btn-fuchsia w-100 px-2" disabled>${window.wishlistStrings.sold_out}</button>`}
                </div>
              </div>
            </div>
          `;
    }).join('')}
      </div>
    `;
  } else {
    html = `<p class="text-center my-5">${window.wishlistStrings.wishlist_empty_state}</p>`;
  }

  document.querySelector('[data-wishlist-details]').innerHTML = html;
  if (products_data.length > 0) {
    setTimeout(() => {
      moveWishlistItemToCart();
      removeWishlistItem(document.querySelectorAll('[data-remove-wishlist]'));
    }, 100);
  }
};
const moveWishlistItemToCart = () => {
  let atcBtns = document.querySelectorAll('[data-move-wishlist-to-cart]');
  let cartElement = document.querySelector('ajax-cart');
  if (atcBtns.length > 0) {
    atcBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {

        e.preventDefault();
        let currBtn = e.currentTarget;
        currBtn.classList.add('disabled');

        let body = JSON.stringify({
          id: currBtn.dataset.variantId,
          quantity: 1
        })

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then(() => {
            cartElement.getCartData('open_drawer');
          })
          .catch((e) => {
            console.error(e);
            Rollbar.error(`failed to add the product from wishlist page - ${e}`)
          })
          .finally(async () => {
            currBtn.removeAttribute('disabled');
          });

      })
    })
  }
}
const initWishlist = (wishlistTrigger) => {
  let customerId = window.globalVariables.customer_id;
  if (wishlistTrigger.length > 0) {
    wishlistTrigger.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (!customerId) {
          window.notificationEle.updateNotification('Saved Favorites', '<a href="/account/login">Login</a> to add item to saved favorites', {
            type: 'error',
            timeout: 6000
          });
          return false
        }

        let currProductID = e.currentTarget.dataset.productId;

        // check if product is already wishlisted and remove if already in wishlist
        if (e.currentTarget.classList.contains('in-wishlist')) {
          wishlist_product_ids = wishlist_product_ids.filter(number => number != currProductID);
          await addWishlistProducts(customerId, wishlist_product_ids);
          let productTitle = wishlisted_products.find(item => {return item.id == currProductID});
          window.notificationEle.updateNotification('Saved Favorites', `${productTitle.title ? `${productTitle.title}` : `The product`} ${window.wishlistStrings.wishlist_removed_item}`, {
            type: 'success',
            timeout: 4000
          });
        } else {
          wishlist_product_ids.push(parseInt(currProductID));
          await addWishlistProducts(customerId, wishlist_product_ids);
          await getWishlistProducts(customerId);
          let productTitle = wishlisted_products.find(item => {return item.id == currProductID});
          window.notificationEle.updateNotification('Saved Favorites', `${productTitle?.title ? `${productTitle.title}` : `The product`} ${window.wishlistStrings.wishlist_added_item}`, {
            type: 'success',
            timeout: 4000
          });
        }
        applyWishlistBtns(wishlist_product_ids);
      })
    });
  }
}

window.addEventListener('DOMContentLoaded', async () => {
  let customerId = window.globalVariables.customer_id;
  let wishlistTrigger = document.querySelectorAll('[data-add-wishlist]');

  // get all the wishlit data and assign on global variables
  if (customerId) {
    await getWishlistProducts(customerId);
    applyWishlistBtns(wishlist_product_ids);
    if (document.querySelector('[data-wishlist-details]')) {
      renderWishlistItems(wishlisted_products);
    }
  }

  // manage add to wishlist toggle function
  initWishlist(wishlistTrigger);

  // Toggle wishlist page
  let triggerBtns = document.querySelectorAll('[data-tab-trigger]');
  if (triggerBtns.length > 0) {
    triggerBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        let currentTab = document.querySelector(`.account-tab-content[${e.currentTarget.dataset.tabTrigger}]`);
        triggerBtns.forEach(btn => (btn != e.currentTarget) ? btn.closest('li').classList.remove('open') : btn.closest('li').classList.add('open'));
        document.querySelectorAll('.account-tab-content')?.forEach(content => content.classList.add('d-none'));
        currentTab?.classList.remove('d-none');
      })
    });
  }
})